export const ReferralRewardsEvents = {
  GetEarned: 'ReferralRewards.GetEarned',
  EarnedReturned: 'ReferralRewards.EarnedReturned',

  GetReferredUsers: 'ReferralRewards.GetReferredUsers',
  ReferredUsersReturned: 'ReferralRewards.ReferredUsersReturned',

  GetRewardsPaid: 'ReferralRewards.GetRewardsPaid',
  RewardsPaidReturned: 'ReferralRewards.RewardsPaidReturned',

  GetWithdrawals: 'ReferralRewards.GetWithdrawals',
  WithdrawalsReturned: 'ReferralRewards.WithdrawalsReturned',

  GetReward: 'ReferralRewards.GetReward',
  RewardCompleted: 'ReferralRewards.RewardCompleted',
}
